import Cookies from 'js-cookie'
import * as types from '@/store/mutations'

const locale = 'en'
const locales = {
  en: 'en',
  ro: 'ro',
}

// state
export const state = {
  locale: Cookies.get('locale') || locale,
  locales: locales,
}

// getters
export const getters = {
  locale: (state) => state.locale,
  locales: (state) => state.locales,
}

// mutations
export const mutations = {
  [types.SET_LOCALE]: (state, { locale }) => {
    state.locale = locale
  },
}

// actions
export const actions = {
  setLocale({ commit }, locale) {
    commit(types.SET_LOCALE, locale)

    Cookies.set('locale', locale, { expires: 365 })
  },
}
